module.exports = {
    "bg": {
        "bootstrap-datepicker": "bg",
        "moment": "bg",
        "datatables": "bulgarian"
    },
    "en": {
        "bootstrap-datepicker": "en-GB",
        "moment": "en-gb",
        "datatables": "english"
    }
};


//////////////////
// WEBPACK FOOTER
// ./Frontend/intl-map.js
// module id = 3
// module chunks = 2